export var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getSchemaListlAction";
    Actions["GET_DETAIL"] = "getSchemaDetailAction";
    Actions["POST_DATA"] = "postSchemaAction";
    Actions["UPDATE_DATA"] = "putSchemaAction";
    Actions["DELETE_DATA"] = "deleteSchemaAction";
    Actions["CREATE_EXPORT"] = "createExportSchemaAction";
    Actions["CHANGE_EXPORT"] = "changeExportSchemaAction";
    Actions["DOWNLOAD"] = "downloadSchemaAction";
    Actions["UPLOAD_CREATE"] = "uploadCreateSchemaAction";
    Actions["UPLOAD_SUBMIT_CREATE"] = "uploadSubmitCreateSchemaAction";
    Actions["UPLOAD_CHANGE"] = "uploadChangeSchemaAction";
    Actions["UPLOAD_SUBMIT_CHANGE"] = "uploadSubmitChangeSchemaAction";
    Actions["GET_ANSWER_TYPE_BY_DETAIL"] = "getAnswerTypeBySchemaDetailAction";
    Actions["GET_COMPETENCY_BY_SCHEMA_ANSWERTYPE"] = "getCompetencyBySchemaAnswertypeAction";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_ORDER"] = "setSchemaOrderByMutation";
    Mutations["SET_SCHEMA_LIST"] = "setSchemaListMutation";
    Mutations["SET_SCHEMA_LIST_LOADING"] = "setSchemaListLoadingMutation";
    Mutations["SET_SCHEMA_LIST_PAGINATION"] = "setSchemaListPaginationMutation";
    Mutations["SET_SCHEMA_LIST_FILTER"] = "setSchemaListFilterMutation";
    Mutations["RESET_SCHEMA_LIST_FILTER"] = "resetSchemaListFilterMutation";
})(Mutations || (Mutations = {}));
